module.exports = __webpack_public_path__ + "img/undraw_Team_page_re_cffb.ff54f80b.svg";